<template>
  <div class="loader">
    <spinner-icon
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
import SpinnerIcon from 'components/icons/SpinnerIcon'

export default {
  name: 'Spinner',
  components: {
    SpinnerIcon
  },
  props: {
    width: {
      type: [Number, String],
      default: () => 40
    },
    height: {
      type: [Number, String],
      default: () => 40
    }
  }
}
</script>

<style lang="sass" scoped>
.loader
  animation: rotate 2s linear infinite
  z-index: 2
  display: inline-block
  border: 0
  width: auto
  height: auto
  border: 1px solid transparent // Fix trembling loader icon

@keyframes rotate
  100%
    transform: rotate(360deg)
</style>



// WEBPACK FOOTER //
// src/components/ui/Spinner.vue